import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import BranchesList from '../../components/BranchesList';
import {
  getBranches,
  openEditBranchDialogDispatch,
  BranchEditClickDispatch,
  fetchAllCompaniesDispatch,
  showDeleteOrDeactiveBranchDialogStateChanged
} from '../../actions';

const mapStateToProps = (state, ownProps) => {
  return {
    branches: state.branches.allBranches.items,
    companies: state.companies.allCompanies.items
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchAllBranches: () => {
      dispatch(getBranches());
    },
    openDeleteOrDeactiveBranchDialog: (open, branchId, status) => {
      dispatch(
        showDeleteOrDeactiveBranchDialogStateChanged(open, branchId, status)
      );
    },
    onBranchEditClick: (branch) => {
      dispatch(openEditBranchDialogDispatch(true));
      dispatch(BranchEditClickDispatch(branch));
    },
    fetchAllCompanies: () => {
      dispatch(fetchAllCompaniesDispatch());
    }
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BranchesList)
);
